import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import profileService from "services/profileService";

const toMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export default function useBusinessLocationTypes() {
  const [locationTypes, setLocationTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLocationTypes = useCallback(async () => {
    setLoading(true);
    try {
      const page = await profileService.businessLocationTypes.list({
        page: 0,
        size: 100,
        active: true,
      });
      setLocationTypes(Array.isArray(page?.content) ? page.content : []);
    } catch (err) {
      toast.error(toMessage(err, "Failed to load business location types"));
    } finally {
      setLoading(false);
    }
  }, []);

  return { locationTypes, loading, fetchLocationTypes };
}

